import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import SlidePanel from "./SlidePanel";
import { BadgeIcons } from "./Badges";

const MEDALS = { 1: "🥇", 2: "🥈", 3: "🥉" };

function Row({ r, me, onOpenUser }) {
  const mine = me && r.username === me.username;
  return (
    <div
      className={`lb-row lb-clickable${mine ? " lb-me" : ""}${r.rank <= 3 ? ` lb-top lb-top-${r.rank}` : ""}`}
      role="button"
      tabIndex={0}
      onClick={() => onOpenUser && onOpenUser(r.username)}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), onOpenUser && onOpenUser(r.username))}
    >
      <span className="lb-rank">{MEDALS[r.rank] || r.rank}</span>
      <span className="lb-avatar">{r.username[0].toUpperCase()}</span>
      <span className="lb-name">
        <strong>@{r.username}</strong>{mine && <em className="lb-you">you</em>}
        <small>{r.ships} ship{r.ships === 1 ? "" : "s"} · {r.edits} edit{r.edits === 1 ? "" : "s"}</small>
        <BadgeIcons ids={r.badges} max={4} />
      </span>
      <span className="lb-points"><strong>{r.points}</strong><small>pts</small></span>
    </div>
  );
}

export default function Leaderboard({ API_BASE, onClose, onOpenUser }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [showRules, setShowRules] = useState(false);

  useEffect(() => {
    const session = Cookies.get("session");
    fetch(`${API_BASE}/api/leaderboard`, session ? { headers: { Authorization: `Bearer ${session}` } } : undefined)
      .then((r) => r.json())
      .then((d) => (d.error ? setError(d.error) : setData(d)))
      .catch(() => setError("Couldn't load the leaderboard."));
  }, [API_BASE]);

  const me = data?.me;
  const meInList = me && data.leaders.some((l) => l.username === me.username);

  return (
    <SlidePanel title="Contributors" subtitle="Top people building the map" onClose={onClose}>
      {error && <p className="panel-error">{error}</p>}
      {!data && !error && <p className="panel-muted">Loading…</p>}

      {data && (
        <>
          <button className="lb-rules-toggle" onClick={() => setShowRules((v) => !v)} aria-expanded={showRules}>
            How points work <span>{showRules ? "▴" : "▾"}</span>
          </button>
          {showRules && (
            <ul className="lb-rules">
              {data.rules.map((r) => (
                <li key={r.key}><span>{r.label}</span><strong>+{r.points}</strong></li>
              ))}
              <li className="lb-rules-note">Only work an admin has approved earns points.</li>
            </ul>
          )}

          {data.leaders.length === 0 ? (
            <div className="panel-empty">
              <div className="panel-empty-icon">🏆</div>
              <p>No points yet.</p>
              <p className="panel-muted">Submit a shipwreck or improve an existing one to get on the board.</p>
            </div>
          ) : (
            <div className="lb-list">
              {data.leaders.map((r) => <Row key={r.username} r={r} me={me} onOpenUser={onOpenUser} />)}
            </div>
          )}

          {me && !meInList && (
            <div className="lb-self">
              <p className="panel-hint">{me.rank ? `Your position` : "You're not on the board yet — get a ship or edit approved!"}</p>
              {me.rank && <Row r={me} me={me} onOpenUser={onOpenUser} />}
            </div>
          )}
        </>
      )}
    </SlidePanel>
  );
}
